<template>
<div class="row fail cancel text-center">
    <img src="/mtn/assets/failed.png" alt="" class="confirmimage">
    <p class="payment-cancel" style="width: 100%;">You cancelled the payment process</p>
    <p class="pay-date" style="width: 100%;">{{ date }}</p>
    <button @click.prevent="close" class="submit modal-trigger modal-close">OK</button>
</div>
</template>

<script>
/* eslint-disable */
export default {
    name: 'Cancel',
    methods: {
        close(){
            this.$parent.closeIframe()
        },
    },
    data(){
        return {
            date : '',
        }
    },
    mounted() {
        this.date = this.$todaysDate()
    },
}

</script>